import { Crash } from '@trace/types';
import { useContext } from 'react';
import { useQuery, UseQueryResult } from 'react-query';

import { ApiContext } from '../Api/Api';

export type HookResult = UseQueryResult<Crash>;

const useCrash = (id: string | number): HookResult => {
  const { get } = useContext(ApiContext);

  return useQuery<Crash>(['crash', id], async () => get(`/issues/${id}`));
};

export default useCrash;
